export default {
  all({ data }) {
    return data;
  },

  allSepData({ sepData }) {
    return sepData;
  },

  separatedData({ sepData, year }) {
    if (!sepData) {
      return null;
    }

    return sepData[year];
  },

  allYears({ data }) {
    return Object.keys(data);
  },
};
